export default __webpack_public_path__ + "src/assets/icn-mnycrpto-app.f91a35ee87a2bf94665e145e7b691099.svg";